/**
 * The template to open when a group URL has no template id: the oldest active
 * (non-archived) one. Ties break on id so the pick is stable.
 * @param templates the group's templates
 */
export const oldestActiveTemplateID = (
	templates: readonly { id: string; createdAt?: string | null }[],
) => {
	if (templates.length === 0) {
		return undefined;
	}

	return [...templates].sort((left, right) => {
		const leftTime = left.createdAt ? Date.parse(left.createdAt) : Number.POSITIVE_INFINITY;
		const rightTime = right.createdAt ? Date.parse(right.createdAt) : Number.POSITIVE_INFINITY;
		if (leftTime !== rightTime) {
			return leftTime - rightTime;
		}

		return left.id.localeCompare(right.id);
	})[0]?.id;
};
